export default __webpack_public_path__ + "static/media/EM0333.34I-41680_-25115_0.2547e11e.jpg";